<script lang="ts">
  import { FilterIcon } from "lucide-svelte";

  import tooltip from "$lib/tooltip";

  interface Props {
    onclick: () => void;
    label: string;
  }

  let { onclick, label }: Props = $props();
</script>

<button
  use:tooltip={label}
  {onclick}
  class="text-zinc-300 block hover:text-brand-green"
>
  <FilterIcon size={14} />
</button>
